import { Injectable } from '@angular/core';
import { driver, type Config, type DriveStep } from 'driver.js';

// No cross-component interactions are required for this tour, so the context is empty.
export type BillingOnboardingTourContext = Record<string, never>;

@Injectable({ providedIn: 'root' })
export class BillingOnboardingTourService {
  start(_context: BillingOnboardingTourContext = {}): void {
    const steps: DriveStep[] = [
      {
        element: '#tour-onboarding-header',
        popover: {
          title: 'Client Onboarding — Overview',
          description:
            'This wizard guides you through creating a new customer in Rev.io from NS data. It collects customer info, billing addresses, services, and products step by step.',
          side: 'bottom',
          align: 'start',
        },
      },
      {
        element: '#tour-stepper',
        popover: {
          title: 'Wizard Steps',
          description:
            'Each tab represents a phase of the onboarding. Steps must be completed in order — a step unlocks once the previous one is validated and saved.<br><br>' +
            '• <strong>Customer</strong> — billing contact and account details<br>' +
            '• <strong>Locations</strong> — service addresses for billing<br>' +
            '• <strong>Services</strong> — service types to activate<br>' +
            '• <strong>Products</strong> — product codes and quantities per location<br>' +
            '• <strong>Summary</strong> — review and submit to Rev.io',
          side: 'top',
          align: 'start',
        },
      },
      {
        element: '#tour-onboarding-back',
        popover: {
          title: 'Records List',
          description:
            'Use the back button to return to the onboarding records list, which shows all in-progress and completed onboarding tasks.',
          side: 'bottom',
          align: 'start',
        },
      },
    ];

    const config: Config = {
      showProgress: true,
      nextBtnText: 'Next',
      prevBtnText: 'Back',
      doneBtnText: 'Done',
      progressText: '{{current}} of {{total}}',
      steps,
    };

    driver(config).drive();
  }
}
